/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Property } from 'csstype';
import { getScopedTheme, getStylist } from 'src/core/themes/luisStylist';

const { styleComponent, styleDiv } = getStylist('Dashboard');
const legendTheme = getScopedTheme('Dashboard');

export const Row = styleDiv('Row', { display: 'table-row', verticalAlign: 'middle' });

export const EmptyRow = styleComponent(Row)('EmptyRow', theme => ({ height: theme.emptyRowHeight }));

export const StatsText = styleDiv<{ bold?: boolean; font?: string; lineHeight?: string }>(
    'StatsText',
    {},
    ({ customProps: { bold, font, lineHeight } }, theme) => ({
        textAlign: 'right',
        display: 'table-cell',
        letterSpacing: theme.largeLetterSpacing,
        fontSize: font || legendTheme.labelFontSize,
        lineHeight: lineHeight || legendTheme.mediumLineHeight,
        fontWeight: bold ? (theme.boldFont as Property.FontWeight) : (theme.semiboldFont as Property.FontWeight)
    })
);

export const ComparisonItem = styleDiv<{ isBadResult?: boolean; rowType: 'predictions' | 'stats' }>(
    'ComparisonItem',
    {},
    ({ customProps: { isBadResult, rowType } }, theme) => {
        const result = {
            fontStyle: 'italic',
            display: 'table-cell',
            fontSize: theme.xSmallFont,
            lineHeight: theme.largeLineHeight,
            width: theme.comparisonLegendItemWidth,
            letterSpacing: theme.xLargeLetterSpacing,
            paddingLeft: theme.comparisonLegendItemSpacing,
            fontWeight: theme.boldFont as Property.FontWeight
        };

        switch (rowType) {
            case 'predictions':
                return { ...result, color: isBadResult ? theme.badComparisonColor : theme.goodComparisonColor };
            case 'stats':
                return { ...result, color: theme.statsComparisonColor };
            default:
        }
    }
);

export const LegendLabel = styleDiv('Label', theme => ({
    display: 'table-cell',
    verticalAlign: 'middle',
    fontSize: theme.mediumFontSize,
    paddingLeft: theme.legendSpacing,
    lineHeight: theme.largeLineHeight,
    letterSpacing: theme.mediumLetterSpacing,
    $nest: {
        button: {
            verticalAlign: 'middle'
        }
    }
}));
